import { IsArray, ValidateNested } from "class-validator";
import { Type } from "class-transformer";

import { ScoreDogClassDto } from "./score-dog-class.dto";
import { IDogShowClassesMoveUp } from "./dog-show-classes-moveup.interface";

export class DogShowClassesMoveUpDto implements IDogShowClassesMoveUp {
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => ScoreDogClassDto)
  dog_classes: ScoreDogClassDto[];
}
